import PDFjsWorkerUrl from "../../src/pdfjs-worker?worker&url";

export const WorkerUrl = PDFjsWorkerUrl;
